import { VisualisationContextProps } from 'widgets/supportVisualisation/Content/VisualisationContentProps.ts';

import {
    Button,
    NumericTextInput,
    TextInput,
} from '@instinet-analytics/semantic-ui-components';
import { useServices } from 'app/hooks.ts';
import React, { useState } from 'react';
import { useAppSelector } from 'store/hooks.ts';
import { selectTradeDatesState } from 'tradeDates/store/tradeDatesSlice.ts';
import JsonPanel from 'utils/components/JsonPanel/JsonPanel.tsx';
import { useSelectAppSettings } from 'app/store/appSettings/selectors.ts';

export default function TradeDatesTest(_props: VisualisationContextProps) {
    const { symbology } = useSelectAppSettings();
    const { tradeDatesService } = useServices();
    const [symbol, setSymbol] = useState('');
    const [ndays, setndays] = useState(-7);

    const tradeDatesState = useAppSelector(selectTradeDatesState);

    const onNDaysChanged = (text: string) => {
        setndays(parseInt(text));
    };

    const onClickGo = () => {
        tradeDatesService.requestTradeDates(
            symbol,
            symbology,
            ndays < 0 ? ndays * -1 : 0,
            ndays > 0 ? ndays : 0
        );
    };

    return (
        <div className="TradeDatesTest">
            <div>
                <div className="symbol">
                    <div className="title">Symbol:</div>
                    <TextInput
                        className="Symbol-input"
                        value={symbol}
                        onChange={setSymbol}
                        placeholder={'Symbol'}
                    />
                </div>

                <div className="ndays">
                    <div className="title">Days:</div>
                    <NumericTextInput
                        className="days-input"
                        value={ndays}
                        onChange={onNDaysChanged}
                        placeholder={'ndays'}
                    />
                </div>
            </div>
            <Button
                className="primary"
                onClick={onClickGo}
                disabled={symbol === ''}
            >
                Send
            </Button>
            <JsonPanel data={tradeDatesState} />
        </div>
    );
}
